import { render } from "./AccessoryDetails.vue?vue&type=template&id=0dd0daf6"
import script from "./AccessoryDetails.vue?vue&type=script&lang=js"
export * from "./AccessoryDetails.vue?vue&type=script&lang=js"

import "./AccessoryDetails.vue?vue&type=style&index=0&id=0dd0daf6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__